export default __webpack_public_path__ + "static/media/visibility_off_black_24dp.af3e7a5e.svg";